import Breadcrumb from "../../../../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../../../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../../../../components/actions/ActionButtons.vue";
import { TransacaoEmpenhoSIAFService } from "../../../../../services/TransacaoEmpenhoSIAFService";

export default {
  name: "GerenciarTransacoesEmpenhoSIAF",
  components: {
    Breadcrumb,
    StandardPagination,
    ActionButtons
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Empenhos SIAF',
        disabled: false,
        href: '/gerenciar-empenhos-siaf',
      },
      {
        text: 'Gerenciar Transações de Empenho',
        disabled: true
      }
    ],
    showFilters: true,
    loading: false,
    items: [],
    itemSelected: [],
    filters: {
      ano_exercicio: null,
      codigo_unidade_executora: null,
      numero_empenho: null,
      projeto_atividade: null,
      elemento_item: null,
      grupo: null,
      fonte: null,
      codigo_transacao_apropriacao: null
    },
    currentPage: 1,
    totalItems: 0,
    itemsPerPage: 10,
    itemsPerPageOptions: [10, 25, 50, 100],
    headers: [
      { text: 'Ano Exercício', value: 'ano_exercicio', align: 'start', sortable: false, width: '120px', class: 'text-left' },
      { text: 'Unidade Executora', value: 'codigo_unidade_executora', align: 'start', sortable: false, width: '150px', class: 'text-left' },
      { text: 'Número Empenho', value: 'numero_empenho', align: 'start', sortable: false, width: '140px', class: 'text-left' },
      { text: 'Projeto-Atividade', value: 'projeto_atividade_completo', align: 'start', sortable: false, width: '200px', class: 'text-left' },
      { text: 'El. Item', value: 'elemento_item_completo', align: 'start', sortable: false, width: '200px', class: 'text-left' },
      { text: 'Grupo', value: 'grupo_completo', align: 'start', sortable: false, width: '200px', class: 'text-left' },
      { text: 'Fonte', value: 'fonte_completa', align: 'start', sortable: false, width: '150px', class: 'text-left' },
      { text: 'Código Transação – Apropriação', value: 'codigo_transacao_apropriacao', align: 'start', sortable: false, width: '180px', class: 'text-left' },
      { text: 'Valor Inicial Empenho', value: 'valor_inicial_empenho', align: 'end', sortable: false, width: '160px', class: 'text-right' },
      { text: 'Valor Reforço Empenho', value: 'valor_reforco_empenho', align: 'end', sortable: false, width: '160px', class: 'text-right' },
      { text: 'Valor Anulação Empenho', value: 'valor_anulacao_empenho', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Despesa Empenhada', value: 'valor_despesa_empenhada', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Apropriação Despesa', value: 'valor_apropriacao_despesa', align: 'end', sortable: false, width: '200px', class: 'text-right' },
      { text: 'Valor Apropriação Multa', value: 'valor_apropriacao_multa', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Liquidado Multa Contratual', value: 'valor_liquidado_multa_contratual', align: 'end', sortable: false, width: '220px', class: 'text-right' },
      { text: 'Valor Anulação Multa', value: 'valor_anulacao_multa', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Apropriação Retenção', value: 'valor_apropriacao_retencao', align: 'end', sortable: false, width: '200px', class: 'text-right' },
      { text: 'Valor Anulação Retenção', value: 'valor_anulacao_retencao', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Além Crédito', value: 'valor_alem_credito', align: 'end', sortable: false, width: '160px', class: 'text-right' },
      { text: 'Valor Liquidado Bruto', value: 'valor_liquidado_bruto', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor em Liquidação', value: 'valor_em_liquidacao', align: 'end', sortable: false, width: '170px', class: 'text-right' },
      { text: 'Valor Saldo Liquidado Bruto', value: 'valor_saldo_liquidado_bruto', align: 'end', sortable: false, width: '220px', class: 'text-right' },
      { text: 'Valor Anulação Saldo Liquidado', value: 'valor_anulacao_saldo_liquidado', align: 'end', sortable: false, width: '230px', class: 'text-right' },
      { text: 'Valor Liquidado Retido', value: 'valor_liquidado_retido', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Saldo de Empenho', value: 'valor_saldo_empenho', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Despesa Liquidada', value: 'valor_despesa_liquidada', align: 'end', sortable: false, width: '190px', class: 'text-right' },
      { text: 'Valor Pago Orçamentário', value: 'valor_pago_orcamentario', align: 'end', sortable: false, width: '190px', class: 'text-right' },
      { text: 'Valor Pago Financeiro', value: 'valor_pago_financeiro', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Pago Pendente', value: 'valor_pago_pendente', align: 'end', sortable: false, width: '170px', class: 'text-right' },
      { text: 'Valor Desconto Pagamento Orçamentário', value: 'valor_desconto_pagamento_orcamentario', align: 'end', sortable: false, width: '260px', class: 'text-right' },
      { text: 'Valor Despesa Liquidada a Pagar', value: 'valor_despesa_liquidada_pagar', align: 'end', sortable: false, width: '230px', class: 'text-right' },
      { text: 'Valor Despesa Realizada', value: 'valor_despesa_realizada', align: 'end', sortable: false, width: '190px', class: 'text-right' },
      { text: 'Valor Anulação Despesa Paga', value: 'valor_anulacao_despesa_paga', align: 'end', sortable: false, width: '210px', class: 'text-right' },
      { text: 'Valor Inscrito Processado', value: 'valor_inscrito_processado', align: 'end', sortable: false, width: '200px', class: 'text-right' },
      { text: 'Valor Inscrito Não Processado', value: 'valor_inscrito_nao_processado', align: 'end', sortable: false, width: '220px', class: 'text-right' },
      { text: 'Valor Pago Antecipado', value: 'valor_pago_antecipado', align: 'end', sortable: false, width: '180px', class: 'text-right' },
      { text: 'Valor Anulação Pago Antecipado', value: 'valor_anulacao_pago_antecipado', align: 'end', sortable: false, width: '230px', class: 'text-right' },
      { text: 'Valor Desconto Título', value: 'valor_desconto_titulo', align: 'end', sortable: false, width: '170px', class: 'text-right' },
      { text: 'Valor Pago Antecipado Liquidado', value: 'valor_pago_antecipado_liquidado', align: 'end', sortable: false, width: '230px', class: 'text-right' }
    ],
    valoresColumns: [
      { value: 'valor_inicial_empenho' },
      { value: 'valor_reforco_empenho' },
      { value: 'valor_anulacao_empenho' },
      { value: 'valor_despesa_empenhada' },
      { value: 'valor_apropriacao_despesa' },
      { value: 'valor_apropriacao_multa' },
      { value: 'valor_liquidado_multa_contratual' },
      { value: 'valor_anulacao_multa' },
      { value: 'valor_apropriacao_retencao' },
      { value: 'valor_anulacao_retencao' },
      { value: 'valor_alem_credito' },
      { value: 'valor_liquidado_bruto' },
      { value: 'valor_em_liquidacao' },
      { value: 'valor_saldo_liquidado_bruto' },
      { value: 'valor_anulacao_saldo_liquidado' },
      { value: 'valor_liquidado_retido' },
      { value: 'valor_saldo_empenho' },
      { value: 'valor_despesa_liquidada' },
      { value: 'valor_pago_orcamentario' },
      { value: 'valor_pago_financeiro' },
      { value: 'valor_pago_pendente' },
      { value: 'valor_desconto_pagamento_orcamentario' },
      { value: 'valor_despesa_liquidada_pagar' },
      { value: 'valor_despesa_realizada' },
      { value: 'valor_anulacao_despesa_paga' },
      { value: 'valor_inscrito_processado' },
      { value: 'valor_inscrito_nao_processado' },
      { value: 'valor_pago_antecipado' },
      { value: 'valor_anulacao_pago_antecipado' },
      { value: 'valor_desconto_titulo' },
      { value: 'valor_pago_antecipado_liquidado' }
    ]
  }),
  created() {
    this.carregarTransacoes();
  },
  watch: {
    currentPage: async function(newValue) {
      this.currentPage = newValue;
      await this.carregarTransacoes();
    },
    'filters.ano_exercicio': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.codigo_unidade_executora': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.numero_empenho': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.projeto_atividade': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.elemento_item': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.grupo': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.fonte': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
    'filters.codigo_transacao_apropriacao': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.carregarTransacoes();
      }
    },
  },
  methods: {
    async carregarTransacoes() {
      try {
        this.loading = true;

        const filter = this.prepareFormFilter();

        const response = await TransacaoEmpenhoSIAFService.search(filter);

        if (!response.error && response.data) {
          this.items = response.data.data || [];
          this.currentPage = response.data.current_page || 1;
          this.totalItems = response.data.total || 0;
        }
      } catch (error) {
        console.error('Erro ao carregar transações:', error);
        this.$globalAlert('Erro ao carregar transações.', 'error');
      } finally {
        this.loading = false;
      }
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.carregarTransacoes();
    },
    handleItemsPerPageChange(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.currentPage = 1;
      this.carregarTransacoes();
    },
    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    prepareFormFilter() {
      const filter = new FormData();
      filter.append("page", this.currentPage);
      filter.append("items_per_page", this.itemsPerPage);

      if (this.filters.ano_exercicio) {
        filter.append("ano_exercicio", this.filters.ano_exercicio);
      }
      if (this.filters.codigo_unidade_executora) {
        filter.append("codigo_unidade_executora", this.filters.codigo_unidade_executora);
      }
      if (this.filters.numero_empenho) {
        filter.append("numero_empenho", this.filters.numero_empenho);
      }
      if (this.filters.projeto_atividade) {
        filter.append("projeto_atividade", this.filters.projeto_atividade);
      }
      if (this.filters.elemento_item) {
        filter.append("elemento_item", this.filters.elemento_item);
      }
      if (this.filters.grupo) {
        filter.append("grupo", this.filters.grupo);
      }
      if (this.filters.fonte) {
        filter.append("fonte", this.filters.fonte);
      }
      if (this.filters.codigo_transacao_apropriacao) {
        filter.append("codigo_transacao_apropriacao", this.filters.codigo_transacao_apropriacao);
      }

      return filter;
    }
  }
};

